
import {classPrefix} from './types';
import {makeStyles} from '@material-ui/core';

/** Styles for edit booking notes dialog */
export const useStyles = makeStyles({
  root: {
    [`& .${classPrefix}-MuiIconButton-root`]: {
      top: 8,
      right: 8,
      color: 'white',
      position: 'absolute'
    }
  },
  titleContainer: {
    color: 'white',
    backgroundColor: 'black',
    cursor: 'grab',
    userSelect: 'none',
    display: 'flex',
    flexDirection: 'row',
    padding: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  noteIcon: {
    marginTop: 3,
    marginRight: 7,
    color: 'rgba(255,255,255,0.87)',
  },
  titleText: {
    alignItems: 'center',
    padding: '0 6px',
    background: 'transparent',
    whiteSpace: 'nowrap',
    minWidth: '88px',
    textAlign: 'center',
    fontSize: 20,
  },

  noteContainer: {
    padding: 16,
  },

  btnContainer: {
    padding: 16,
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },

  btnSave: {
    marginLeft: '15px !important',
  },

  textArea: {

    [`& .${classPrefix}-MuiInputBase-root`]: {
      padding: '2px 0px'
    },

    [`& .${classPrefix}-MuiInputBase-input`]: {
      fontSize: '16px',
      lineHeight: '1.3',
      color: 'rgba(0, 0, 0, 0.54)'
    },

    [`& .${classPrefix}-MuiFormControl-root`]: {
      margin: '10px 0 0 0'
    },

    [`& .${classPrefix}-MuiFormLabel-root`]: {
      fontSize: '16px',
      color: '#101010'
    },

    [`& .${classPrefix}-MuiInputLabel-shrink`]: {
      transform: 'translate(0, 0)'
    },
    marginBottom: '5px'
  },
});
